import { RankBadgeProps } from '../types';

export function RankBadge({ rank, size = 'md' }: RankBadgeProps) {
  const getRankClass = (rank: number) => {
    if (rank === 1) return 'rank-1';
    if (rank === 2) return 'rank-2';
    if (rank === 3) return 'rank-3';
    return 'rank-default';
  };

  const getSizeClasses = (size: string) => {
    switch (size) {
      case 'sm':
        return 'w-6 h-6 text-xs';
      case 'lg':
        return 'w-12 h-12 text-lg';
      default:
        return 'w-8 h-8 text-sm';
    }
  };

  const getRankIcon = (rank: number) => {
    if (rank === 1) return '👑';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return rank.toString();
  };

  return (
    <div
      className={`
        ${getRankClass(rank)}
        ${getSizeClasses(size)}
        rounded-full
        flex items-center justify-center
        font-bold text-white
        shadow-lg
        animate-scale-in
      `}
    >
      {getRankIcon(rank)}
    </div>
  );
}
